import * as config from '@/config/config.json';
import * as calculatorConfig from '@/config/base-config.json';
import {
  BEFORE_FOUNDATION_STAGE,
  CAR_PARK_STAGE,
  CEILING_STAGE,
  FOUNDATION_STAGE,
  FRAMEWORK_STAGE,
  UTILITY_STAGE,
  WALL_STAGE,
  WINDOW_STAGE,
} from '../buc';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const CI_RESALE_VS_BUC_LABEL = {
  AssumingYearsAfterPurchase: 'Assuming Years After Purchase',
  Resale: 'Resale',
  PurchasePrice: 'Purchase Price',
  LoanTenure: 'Loan Tenure (Years)',
  MortgageLoanInterestRate: 'Mortgage Loan Interest Rate',
  LoanToValue: 'Loan-to-Value',
  LoanAmount: 'Loan Amount',
  MonthlyInstalment: 'Monthly Instalment',
  AverageMonthlyInterest: 'Average Monthly Interest',
  AverageMonthlyPrincipal: 'Average Monthly Principal',
  YearlyInterest: 'Yearly Interest',
  YearlyPrincipal: 'Yearly Principal',
  Total: 'Total',
  BuildingUnderConstruction: 'Building Under Construction',
  RentalCost: 'Rental Cost',
  RentalOfCommercialIndustrialUnitPerMonth: 'Rental of Commercial / Industrial Unit Per Month',
  TotalRentalOf: 'Total Rental of',
  Summary: 'Summary',
  InterestTotal: 'Interest Total',
  PrincipalTotal: 'Principal Total',
  Rental: 'Rental',
};

export enum ReviewingYears {
  FIRST_YEAR = '1',
  SECOND_YEAR = '2',
  THIRD_YEAR = '3',
}

export const SummaryColumns = [
  { label: '', accessor: 'item', className: 'min-w-[120px]' },
  {
    label: CI_RESALE_VS_BUC_LABEL.Resale,
    accessor: 'resale',
    className: 'max-w-[150px] min-w-[100px] text-right bg-neutral-50',
  },
  {
    label: CI_RESALE_VS_BUC_LABEL.BuildingUnderConstruction,
    accessor: 'buc',
    className: 'max-w-[150px] text-right',
  },
];

export const ResaleVsBUCStage = [
  BEFORE_FOUNDATION_STAGE,
  FOUNDATION_STAGE,
  FRAMEWORK_STAGE,
  WALL_STAGE,
  CEILING_STAGE,
  WINDOW_STAGE,
  UTILITY_STAGE,
  CAR_PARK_STAGE,
];

export const MONTHLY = 'Monthly';
export const YEARLY = 'Yearly';

export const LOAN_TENURE = {
  LABEL_INPUTS: generateSliderSteps(0, config.max_loan_tenure_in_years.commercial_industrial, 10),
  MAX: config.max_loan_tenure_in_years.commercial_industrial,
  STEP: 1,
  DEFAULT: config.max_loan_tenure_in_years.commercial_industrial,
};

export const CI_MORTGAGE_INTEREST_RATE = {
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.mortgage_interest_rate.commercial_industrial.min,
    calculatorConfig.mortgage_interest_rate.commercial_industrial.max,
    1,
  ),
  DEFAULT: calculatorConfig.mortgage_interest_rate.commercial_industrial.default,
  MAX: calculatorConfig.mortgage_interest_rate.commercial_industrial.max,
  STEP: 0.01,
};

export const CI_LOAN_TO_VALUE = {
  LABEL_INPUTS: generateSliderSteps(0, config.max_ltv_in_percent.commercial_industrial, 15),
  MAX: config.max_ltv_in_percent.commercial_industrial,
  STEP: 1,
  DEFAULT: config.max_ltv_in_percent.commercial_industrial,
};
